import React, { Component, Fragment } from "react";
import { Portal } from "react-portal";
import "./Popup.scss";
import Basket from "../Basket/Basket";
import { BasePopup } from "../../common/BasePopup";
import Loader from "../../common/Loader";
import Login from "../Login/Login";
import { ToastContainer, toast } from "react-toastify";
import {
  API_URL,
  CLIENT_TOKEN,
  BILAN_COUNTER_UNIT,
  ERROR_OCCURED,
} from "../../common/constants";
import Api from "../../common/helpers/Api";

import shortProductId from "../../common/helpers/shortId";
import dayjs from "dayjs";
export default class BasketPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginStatusLoading: true,
      showBasket: false,
      productLoading: true,
      processCompleted: false,
      articles: [],
    };
  }

  async componentDidMount() {
    this.props.store.getCombinationProductRules();
    await this.props.store.getLoginStatus();
    this.setState({ loginStatusLoading: false });
    
  }

  async componentDidUpdate(prevProps) {
    if (
      prevProps.store.contact !== this.props.store.contact &&
      this.props.store.contactUser !== null &&
      this.props.store.contact !== null
    ) {
      if (!this.state.processCompleted) {
        await this.props.store.getUserCart();
        const canBuy = await this.checkPreviousPurchases();
        if (canBuy) await this.checkCombinationRules();
        else {
          // this.props.store.togglePopup("popupBasket", false);
        }
      }
    }
  }

  /**
   * On vérifie que le user n'a pas déjà un bilan actif avant d'en ajouter un nouveau au panier
   *
   * @returns
   * @memberof BasketPopup
   */
  async checkPreviousPurchases() {
    if (!Boolean(parseInt(this.props.canBuyMany))) {
      if (this.props.productType === "bilan") {
        const { error, purchases } = await this.getPurchases();

        if (error === null) {
          const activePurchasedBilan = await purchases.filter(
            (p) =>
              p.counterUnitName === BILAN_COUNTER_UNIT &&
              p.remainingUnits > 0 &&
              dayjs(p.expirationDate).isAfter(dayjs())
          );
          if (activePurchasedBilan.length > 0) {
            // toast.error("Vous avez déjà un bilan à utiliser");
            this.props.toastSomething("Vous avez déjà un bilan à utiliser");
            return false;
          } else {
            return true;
          }
        } else {
          toast.error(ERROR_OCCURED);
          return false;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  async getPurchases() {
    try {
      const response = await Api.get("counter_summary", {
        params: { contact: this.props.store.contactUser.contactId },
      });
      const { data } = response;
      return { error: null, purchases: data };
    } catch (error) {
      console.log(error);
      return { error: "Une erreur s'est produite" };
    }
  }

  async checkCombinationRules() {
    const { articles } = await this.getArticlesFromCart(
      this.props.store.cartId
    );
    // On recupere les regles de combinaison du produit que l'on va ajouter
    const articleToAddRules = await this.props.store.combinationProductRules.products.find(
      (p) => parseInt(this.props.productId) === p.id
    );
    if (articleToAddRules) {
      // On filtre les articles du panier pour ne garder que ceux qui ne sont pas combinables avec le produit que l'on tente d'ajouter
      const blockingCombination = await Promise.all(
        articles.filter((art) => {
          return articleToAddRules.cannotCombineWith.includes(
            shortProductId(art)
          );
        })
      );

      if (blockingCombination && blockingCombination.length) {
        let cantCombineMessage = "Ce produit n'est pas cumulable avec ";

        if (
          blockingCombination.some(
            (a) => shortProductId(a) === articleToAddRules.id
          )
        ) {
          cantCombineMessage = "Vous ne pouvez pas ajouter 2 fois ce produit";
        } else {
          blockingCombination.map((p, i) => {
            if (i !== blockingCombination.length - 1) {
              cantCombineMessage += p.productName + " et ";
            } else {
              cantCombineMessage += p.productName;
            }
          });
        }
        toast.error(cantCombineMessage);

        await this.setState({
          showBasket: true,
          productLoading: false,
          processCompleted: true,
        });
        return; //On sort de la fonction pour ne pas appeler le addTo cart
      }
    }
    await this.addToCart();
    this.setState({ processCompleted: true });
  }

  async addToCart() {
    // await this.setState({ productLoading: true });

    const productResponse = await this.getProduct();
    console.log(productResponse);

    if (productResponse.error) {
      this.setState({ error: productResponse.error, productLoading: false });
      return;
    }
    const result = await this.props.store.addProductToSale(
      productResponse.product.offers[0]
    );
    if (result.sale && result.sale["hydra:member"]) {
      this.setState({
        showBasket: true,
        productLoading: false,
      });

      toast.success("Produit ajouté au panier");
    } else {
      // this.setState({ addToCartLoading: false });
      toast.error("Une erreur s'est produite");
    }
    console.log(result);
  }

  async getArticlesFromCart(cartId) {
    if (!cartId) {
      console.log("cartId", cartId);
      return { articles: [] };
    }

    try {
      const response = await Api.get("articles", {
        params: {
          sale: cartId,
        },
      });
      const { data } = response;

      if (data["hydra:member"])
        return { articles: data["hydra:member"], error: null };
      else return { error: null, articles: [] };
    } catch (reason) {
      if (reason.response) {
        if (reason.response.status === 400) {
          return { error: "Identifiants inconnus" };
        } else {
          return { error: "Une erreur s'est produite" };
        }
      }
    }
  }

  async getProduct() {
    try {
      const response = await Api.get(
        API_URL + CLIENT_TOKEN + "products/" + this.props.productId
      );

      const { data } = response;

      return { product: data, error: null };
    } catch (reason) {
      return { error: true };
    }
  }

  render() {
    const { store } = this.props;
    const { loginStatusLoading, productLoading } = this.state;
    return (
      <Fragment>
        <Portal>
          <BasePopup
            store={store}
            popupName="popupBasket"
            closeOnClickingOutside={false}
            className={`${
              !store.isUserLoggedIn() ? "login-popup" : "booking-popup"
            } ${productLoading ? "loading" : ""}`}
          >
            <span
              className="close-button"
              onClick={() => {
                store.togglePopup("popupBasket", false);
              }}
            >
              <i className="fa fa-times" aria-hidden="true" />
            </span>
            {!store.isUserLoggedIn() ? (
              <div
                className={`login-screen ${
                  loginStatusLoading ? "loading" : ""
                }`}
              >
                {loginStatusLoading ? (
                  <Loader color={this.props.loaderColor} />
                ) : (
                  <Login store={store} signupLink={true} />
                )}
              </div>
            ) : (
              <Fragment>
                {this.state.showBasket && !this.state.error ? (
                  <Basket
                    store={store}
                    checkout={false}
                    keepNavigating={true}
                    popupName={"popupBasket"}
                  />
                ) : (
                  <>
                    {this.state.error ? (
                      <div className="error-container">
                        <p className="error">Une erreur s'est produite</p>
                      </div>
                    ) : (
                      <Loader color={this.props.loaderColor} />
                    )}
                  </>
                )}
              </Fragment>
            )}
          </BasePopup>
          {/* <ToastContainer /> */}
        </Portal>
      </Fragment>
    );
  }
}
